const e = [{
  label: "Select All",
  key: "SELECT_ALL"
}, {
  label: "None",
  key: "SELECT_NONE"
}];
export {
  e as headerActions
};
//# sourceMappingURL=perdicate.js.map
